import { ExampleKimItem } from './ExampleKimItem';
import QuestionInput from './QuestionInput';
import SectionCard from '../SectionCard';
import { TrackingEvents } from '@/analytics/events';
import { trackCustomEvent } from '@/analytics/Mixpanel';
import { Case } from '@/api/types/backend-dto-types';
import { KimMode } from '@/types';

interface AskKimSectionProps {
  caseObject: Case | undefined;
  onAskQuestion: (question: string, mode: KimMode) => void;
}

export const AskKimSection = ({ caseObject, onAskQuestion }: AskKimSectionProps) => {
  return (
    <div className="lg:col-span-3">
      <SectionCard title="Ask Kim - Your AI Litigation Assistant" className="h-full">
        <QuestionInput
          onSubmit={(question) => {
            onAskQuestion(question, KimMode.QuestionFlow);
            trackCustomEvent(TrackingEvents.AskKimFromSummaryQuestion);
          }}
        />
        {caseObject &&
          Array.isArray(caseObject?.exampleKimQuestions?.question) &&
          caseObject.exampleKimQuestions.question.length > 0 && (
            <div className="mt-2">
              <div className="grid grid-cols-1 gap-2 sm:grid-cols-2">
                {/* Example Questions */}
                <div>
                  <h4 className="mb-1 text-xs font-semibold text-gray-700">Case analysis:</h4>
                  <div className="space-y-1">
                    {caseObject.exampleKimQuestions.question.map((q: any, idx: number) => (
                      <ExampleKimItem
                        key={idx}
                        text={typeof q === 'string' ? q : q.prompt}
                        type="question"
                        onClick={() => {
                          onAskQuestion(q.prompt, KimMode.QuestionFlow);
                          trackCustomEvent(TrackingEvents.AskKimFromSummaryQuestion);
                        }}
                      />
                    ))}
                  </div>
                </div>
                {/* Example Drafts */}
                {caseObject &&
                  Array.isArray(caseObject.exampleKimQuestions.draft) &&
                  caseObject.exampleKimQuestions.draft.length > 0 && (
                    <div>
                      <h4 className="mb-1 text-xs font-semibold text-gray-700">Outputs and work product:</h4>
                      <div className="space-y-1">
                        {caseObject.exampleKimQuestions.draft.map((d: any, idx: number) => (
                          <ExampleKimItem
                            key={idx}
                            text={typeof d === 'string' ? d : d.prompt}
                            type="draft"
                            onClick={() => {
                              onAskQuestion(d.prompt, KimMode.DraftFlow);
                              trackCustomEvent(TrackingEvents.AskKimFromSummaryDraft);
                            }}
                          />
                        ))}
                      </div>
                    </div>
                  )}
              </div>
            </div>
          )}
      </SectionCard>
    </div>
  );
};
